import React from 'react';
import styled from 'styled-components';

import Caution from '../components/Icons/Caution';
import ArrowDown from '../components/Icons/ArrowDown';
import ArrowLeft from '../components/Icons/ArrowLeft';
import ArrowRight from '../components/Icons/ArrowRight';
import ArrowUp from '../components/Icons/ArrowUp';
import Ball from '../components/Icons/Ball';
import Calendar from '../components/Icons/Calendar';
import Close from '../components/Icons/Close';
import Edit from '../components/Icons/Edit';
import Invite from '../components/Icons/Invite';
import Lock from '../components/Icons/Lock';
import Main from '../components/Icons/Main';
import Menu from '../components/Icons/Menu';
import More from '../components/Icons/More';
import People from '../components/Icons/People';
import Plus from '../components/Icons/Plus';
import PlusBordered from '../components/Icons/PlusBordered';
import MinusBordered from '../components/Icons/MinusBordered';
import Question from '../components/Icons/Question';
import Search from '../components/Icons/Search';
import Settings from '../components/Icons/Settings';
import SortDown from '../components/Icons/SortDown';
import SortUp from '../components/Icons/SortUp';
import Trade from '../components/Icons/Trade';
import Facebook from '../components/Icons/Facebook';
import Twitter from '../components/Icons/Twitter';
import Instagram from '../components/Icons/Instagram';
import Tick from '../components/Icons/Tick';
import Undo from '../components/Icons/Undo';
import User from '../components/Icons/User';
import Guide from '../components/Icons/Guide';
import Star from '../components/Icons/Star';
import Delist from '../components/Icons/Delist';
import Bell from '../components/Icons/Bell';
import ExternalLink from '../components/Icons/ExternalLink';
import ChangeIndicatorDown from '../components/Icons/ChangeIndicatorDown';
import ChangeIndicatorUp from '../components/Icons/ChangeIndicatorUp';
import ChangeIndicatorHold from '../components/Icons/ChangeIndicatorHold';



const ExampleWrapper = styled.div`
	color: red;
	&:hover {
		color: blue;
	}
	&:nth-child(2n) {
		font-size: 30px;
	}
`;

// To color an icon just set the font-color on SVG itself or a parent.
// To resize the icon change the font-size. Use ems if the font needs to scale with text.


export default () => {
	return (
		<div>
			<ExampleWrapper><Caution /></ExampleWrapper>
			<ExampleWrapper><Delist /></ExampleWrapper>
			<ExampleWrapper><Bell /></ExampleWrapper>
			<ExampleWrapper><Star active /></ExampleWrapper>
			<ExampleWrapper><Star /></ExampleWrapper>
			<ExampleWrapper><Guide /></ExampleWrapper>
			<ExampleWrapper><Undo /></ExampleWrapper>
			<ExampleWrapper><User /></ExampleWrapper>
			<ExampleWrapper><Tick /></ExampleWrapper>
			<ExampleWrapper><Facebook /></ExampleWrapper>
			<ExampleWrapper><Instagram /></ExampleWrapper>
			<ExampleWrapper><Twitter /></ExampleWrapper>
			<ExampleWrapper><ArrowDown /></ExampleWrapper>
			<ExampleWrapper><ArrowLeft /></ExampleWrapper>
			<ExampleWrapper><ArrowRight /></ExampleWrapper>
			<ExampleWrapper><ArrowUp /></ExampleWrapper>
			<ExampleWrapper><Ball /></ExampleWrapper>
			<ExampleWrapper><Calendar /></ExampleWrapper>
			<ExampleWrapper><Close /></ExampleWrapper>
			<ExampleWrapper><Edit /></ExampleWrapper>
			<ExampleWrapper><Invite /></ExampleWrapper>
			<ExampleWrapper><Lock /></ExampleWrapper>
			<ExampleWrapper><Main /></ExampleWrapper>
			<ExampleWrapper><Menu /></ExampleWrapper>
			<ExampleWrapper><MinusBordered /></ExampleWrapper>
			<ExampleWrapper><More /></ExampleWrapper>
			<ExampleWrapper><People /></ExampleWrapper>
			<ExampleWrapper><Plus /></ExampleWrapper>
			<ExampleWrapper><PlusBordered /></ExampleWrapper>
			<ExampleWrapper><Question /></ExampleWrapper>
			<ExampleWrapper><Search /></ExampleWrapper>
			<ExampleWrapper><Settings /></ExampleWrapper>
			<ExampleWrapper><SortDown /></ExampleWrapper>
			<ExampleWrapper><SortUp /></ExampleWrapper>
			<ExampleWrapper><Trade /></ExampleWrapper>
			<ExampleWrapper><ExternalLink /></ExampleWrapper>
			<ExampleWrapper><ChangeIndicatorDown /></ExampleWrapper>
			<ExampleWrapper><ChangeIndicatorUp /></ExampleWrapper>
			<ExampleWrapper><ChangeIndicatorHold /></ExampleWrapper>
		</div>
	);
};


// WEBPACK FOOTER //
// ./src/pages/IconExamples.js